import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MinusXs = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsxs("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_8774_22682)",
                children: /*#__PURE__*/ _jsx("path", {
                    clipRule: "evenodd",
                    d: "M2 8C2 7.58579 2.33579 7.25 2.75 7.25H13.25C13.6642 7.25 14 7.58579 14 8C14 8.41421 13.6642 8.75 13.25 8.75H2.75C2.33579 8.75 2 8.41421 2 8Z",
                    fill: color,
                    fillRule: "evenodd"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_8774_22682",
                    children: /*#__PURE__*/ _jsx("rect", {
                        fill: "white",
                        height: "16",
                        width: "16"
                    })
                })
            })
        ]
    });

//# sourceMappingURL=minus-xs.js.map